import { TestRunsExpandedRow as SharedTestRunsExpandedRow } from '@elementary/common-ui/pages';
import { TestRun } from '@elementary/common-ui/types';
import useSnackbar from 'shared/hooks/useSnackbar';
import useTestRunExecutionHistory from '../hooks/useTestRunExecutionHistory';

const TestRunsExpandedRow = ({ rowData }: { rowData: TestRun }) => {
  const { openSnackbar } = useSnackbar();
  const { invocations, isFetching } = useTestRunExecutionHistory({
    subTestUniqueId: rowData.metadata.elementary_unique_id,
  });

  return (
    <SharedTestRunsExpandedRow
      rowData={rowData}
      invocations={invocations}
      isFetching={isFetching}
      onOpenSnackbar={(message) => openSnackbar({ message })}
    />
  );
};

export default TestRunsExpandedRow;
